import { XMPPService } from "src/services/Ejabberd/XMPP";

export const WS_SERVICE = process.env.REACT_APP_XMPP_WS_SERVICE as string;
export const HOST = process.env.REACT_APP_XMPP_HOST as string;
export const GROUP_HOST = process.env.REACT_APP_XMPP_GROUP_HOST as string;

export const xmpp = new XMPPService()
